/* eslint-disable @typescript-eslint/camelcase */
import { commit, make } from "vuex-pathify";

const defaultState = () => {
  return {
    userInfo: {
      userSignedIn: false,
      api_token: "",
      UserName: "",
      UserID: 0,
      Service: "",
      CountyID: 0,
      ServiceDB: "",
      CountyName: ""
    }
  };
};

const state = defaultState();

const mutations = make.mutations(state);

const actions = {
  ...make.actions(state),
  setNewToken({ commit }: { commit: Function }, token: string) {
    commit("SET_USER_INFO", Object.assign({}, state.userInfo, { token }));
  },
  setDefaultState({ commit }: { commit: Function }) {
    commit("SET_USER_INFO", Object.assign({}, state, defaultState().userInfo));
  }
};

const getters = {
  ...make.getters(state)
};

export default {
  state,
  mutations,
  actions,
  getters
};
